import React, { useState } from "react";
import { useNavigate} from "react-router";
import { Container, Row, Col, Card, Button, Image, ListGroup, InputGroup, FormControl,ProgressBar, Modal, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faThumbsUp,faThumbsDown } from '@fortawesome/free-regular-svg-icons'
import {faInfoCircle, faUserCircle, faCheckCircle,faWindowClose } from '@fortawesome/free-solid-svg-icons';
import Icon from "react-crypto-icons";
import './Governance.css';

const Governance = () => {
    const navigate = useNavigate();
    // const location = useLocation();
    // Fictive call to Google Analytics
    // ga.send(["pageview", location.pathname])
    const [showClaimDetailModal, setShowClaimDetailModal] = useState(false);
    const [showVoteDetailModal, setShowVoteDetailModal] = useState(false);
    const cmpgData = [
      {tokenName:"eth", quantity:100, usdValue:40000},
      {tokenName:"dai", quantity:100, usdValue:40000},
      {tokenName:"matic", quantity:100, usdValue:40000},
      {tokenName:"usdt", quantity:100, usdValue:40000},
      {tokenName:"usdc", quantity:100, usdValue:40000},
      {tokenName:"aave", quantity:100, usdValue:40000},
      {tokenName:"wbtc", quantity:100, usdValue:40000}
    ];

    const voteSectionData = [
      {description:"Return unclaimed distributed CMPG to Gov Treasury", status:2, progress:50},
      {description:"Update Cimple Staking allocation", status:0, progress:50},
      {description:"Pass integrate Pooltogether", status:1, progress:50},
      {description:"Return unclaimed distributed CMPG to Gov Treasury", status:2, progress:50},
      {description:"Update Cimple Staking allocation", status:0, progress:50},
      {description:"Pass integrate Pooltogether", status:1, progress:50},
      {description:"Return unclaimed distributed CMPG to Gov Treasury", status:2, progress:50},
      {description:"Update Cimple Staking allocation", status:0, progress:50},
      {description:"Update Cimple Staking allocation", status:1, progress:50}
    ];

    function ClaimDetailModal(props) {
      return (
        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="modal-90x"
        >
          <Modal.Header className='border-bottom-0'>
            <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
              Claim USDT
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='px-5 py-5'>
            <Container fluid>
              <Row className="vertical-center">
                <Col xs={12} md={6}>
                  <h6 className="text-uppercase">Token available to claim</h6>
                  <Icon name="usdt" size={50} /><label className="ml-4">7,499 USDT (1.5 ETH)</label>
                </Col>
                <Col xs={12} md={6}>
                  <FontAwesomeIcon icon={faInfoCircle} color="#20c997" size="lg" />
                  <span className="text-muted">If insurance Account has different cryptocurrency, it would be swapped automatically.</span>
                  <div className="mt-4">
                    <Button variant="outline-primary" className="px-5 py-2 text-uppercase float-left">Distribute quality</Button>
                    <Button variant="primary" className="px-5 py-2 text-uppercase float-right">claim to all</Button>
                  </div>
                </Col>
              </Row>
              <Row className="mt-5">
                <Col xs={12} md={12}>
                  <div className='claim-detail-table table-striped table-borderless border-0 table-responsive'>
                    <table className="table">
                      <thead>
                        <tr>
                            <th>Account</th>
                            <th>Token Amount</th>
                            <th>Insurance</th>
                            <th>Insurance After</th>
                            <th>Insurace Ratio</th>
                            <th>Amount Deposit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='border-top-0'>
                          <td><Icon name="matic" size={25} /><label className="ml-3">MATIC</label></td>
                          <td><Icon name="matic" size={25} /><label className="ml-3">11 MATIC</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><ProgressBar now={56} label={'10% + 3%'} /></td>
                          <td>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="number"
                                placeholder="73 UDST"
                              />
                              <Button variant="outline-secondary">
                                Claim
                              </Button>
                            </InputGroup>
                          </td>
                        </tr>
                        <tr className='border-top-0'>
                          <td><Icon name="matic" size={25} /><label className="ml-3">MATIC</label></td>
                          <td><Icon name="matic" size={25} /><label className="ml-3">11 MATIC</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><ProgressBar now={56} label={'10% + 3%'} /></td>
                          <td>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="number"
                                placeholder="73 UDST"
                              />
                              <Button variant="outline-secondary">
                                Claim
                              </Button>
                            </InputGroup>
                          </td>
                        </tr>
                        <tr className='border-top-0'>
                          <td><Icon name="matic" size={25} /><label className="ml-3">MATIC</label></td>
                          <td><Icon name="matic" size={25} /><label className="ml-3">11 MATIC</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><ProgressBar now={56} label={'10% + 3%'} /></td>
                          <td>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="number"
                                placeholder="73 UDST"
                              />
                              <Button variant="outline-secondary">
                                Claim
                              </Button>
                            </InputGroup>
                          </td>
                        </tr>
                        <tr className='border-top-0'>
                          <td><Icon name="matic" size={25} /><label className="ml-3">MATIC</label></td>
                          <td><Icon name="matic" size={25} /><label className="ml-3">11 MATIC</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><ProgressBar now={56} label={'10% + 3%'} /></td>
                          <td>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="number"
                                placeholder="73 UDST"
                              />
                              <Button variant="outline-secondary">
                                Claim
                              </Button>
                            </InputGroup>
                          </td>
                        </tr>
                        <tr className='border-top-0'>
                          <td><Icon name="matic" size={25} /><label className="ml-3">MATIC</label></td>
                          <td><Icon name="matic" size={25} /><label className="ml-3">11 MATIC</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><label className="ml-3">120 DAI</label><label className="d-block">0.0002 ETH</label></td>
                          <td><ProgressBar now={56} label={'10% + 3%'} /></td>
                          <td>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="number"
                                placeholder="73 UDST"
                              />
                              <Button variant="outline-secondary">
                                Claim
                              </Button>
                            </InputGroup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      );
    }

    function VoteDetailModal(props) {
      return (
        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="lg"
        >
          <Modal.Header className='border-bottom-0'>
            <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
              Return unclaimed distributed CMPG to Gov Treasury
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='px-5 py-5'>
            <h6 className="text-uppercase">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets conta</h6>
            <div className='card-deck mt-1'>
              <div className="card d-inline-block mt-3">
                  <div className="card-body px-2">
                    <div >
                      <p className="card-title d-inline-block h6 float-left">Start Date</p>
                      <p className="d-inline-block float-right h8 float-left">Jul 29, 2021, 8:00PM</p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                      <p className="card-title d-inline-block h6">End Date</p>
                      <p className="d-inline-block float-right h8">Jul 29, 2021, 8:00PM</p>
                    </div>
                  </div>
              </div>
              <div className="card d-inline-block mt-3">
                  <div className="card-body px-2 py-2">
                      <p className="card-title h8" style={{fontSize:"12px"}}>For return unclaimed....</p>
                      <ProgressBar now={56} variant="success" label={'10% + 3%'} />
                      <div className="mt-3"></div>
                      <ProgressBar now={30} variant="danger" label={'10% + 3%'} />
                  </div>
              </div>
            </div>
            <div className="card mt-5">
              <div className="text-center mt-2">BULLETINGS</div>
              <div className='card-body table-borderless border-0 table-responsive'>
                <table className="table">
                  <tbody>
                    <tr className='text-center vertical-center' style={{borderBottom:'1px solid #6c6565'}}>
                      <td style={{width:'20%'}} className="vertical-center"><FontAwesomeIcon icon={faUserCircle} color="#0075c8" size='2x' /><label className="ml-3">Jack</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3">1 CMPG</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3"><FontAwesomeIcon icon={faCheckCircle} color='#20c997' size='2x' /></label><label  className="ml-2">0.0002 ETH</label></td>
                    </tr>
                    <tr className='border-top-0 text-center vertical-center' style={{borderBottom:'1px solid #6c6565'}}>
                      <td style={{width:'20%'}} className="vertical-center"><FontAwesomeIcon icon={faUserCircle} color="#0075c8" size='2x' /><label className="ml-3">Jack</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3">1 CMPG</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3"><FontAwesomeIcon icon={faWindowClose} color='#eb5757' size='2x' /></label><label  className="ml-2">0.0002 ETH</label></td>
                    </tr>
                    <tr className='border-top-0 text-center vertical-center' style={{borderBottom:'1px solid #6c6565'}}>
                      <td style={{width:'20%'}} className="vertical-center"><FontAwesomeIcon icon={faUserCircle} color="#0075c8" size='2x' /><label className="ml-3">Jack</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3">1 CMPG</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3"><FontAwesomeIcon icon={faCheckCircle} color='#20c997' size='2x' /></label><label  className="ml-2">0.0002 ETH</label></td>
                    </tr>
                    <tr className='border-top-0 text-center vertical-center' style={{borderBottom:'1px solid #6c6565'}}>
                      <td style={{width:'20%'}} className="vertical-center"><FontAwesomeIcon icon={faUserCircle} color="#0075c8" size='2x' /><label className="ml-3">Jack</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3">1 CMPG</label></td>
                      <td style={{width:'40%'}} className="vertical-center"><label className="ml-3"><FontAwesomeIcon icon={faWindowClose} color='#eb5757' size='2x' /></label><label className="ml-2">0.0002 ETH</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      );
    }
    return (
      <Container fluid style={{ paddingTop: '1rem', backgroundColor:'#edf2f9' }}>
        <Row>
          <Col xs={12} md={7} lg={7}>
            <Row>
              <Col xs={12} md={6} lg={6}>
                <Card style={{ minHeight: '35rem' }}>
                  <Card.Body>
                    <Card.Title><label className="card-title-small">unstaked balance</label></Card.Title>
                    <Card.Text>
                      <Image src="/img/governance/Cimple_token_unstaked.png"></Image> <label className="text-bolder paddingLeft15">7499 Cimple</label>
                    </Card.Text>
                    <ListGroup variant="flush">
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Current Rate</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small>1,500 GWEI</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Tx Fee Discount value</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small>1,500</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Rate in 1 Year</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small> 36,400 GWEI</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Discount in 1 Year</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small> 1,500 GWEI</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>1 Year increase</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small> 78 %</small>
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </Card.Body>
                  <Card.Footer>
                    <InputGroup className="">
                      <InputGroup.Text id="basic-addon1">Ci</InputGroup.Text>
                      <FormControl
                        placeholder="Recipient's username"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                    </InputGroup>
                    <Button variant="primary" size="md" style={{marginTop:'10px', marginBottom:'10px'}}>Stake More</Button>
                  </Card.Footer>
                </Card>
              </Col>
              <Col xs={12} md={6} lg={6}>
              <Card style={{ minHeight: '35rem' }}>
                  <Card.Body>
                    <Card.Title><label className="card-title-small">staked balance</label></Card.Title>
                    <Card.Text>
                      <Image src="/img/governance/Cimple_token_staked.png"></Image> <label className="text-bolder paddingLeft15">7499 Cimple</label>
                    </Card.Text>
                    <Card.Title><label className="card-title-small">your cmpg balance</label></Card.Title>
                    <Card.Text>
                      <Image src="/img/governance/CMPG_token.png" className="img-responsive" style={{width:'45px', height:'45px'}}></Image> <label className="text-bolder paddingLeft15">7499 Cimple</label>
                    </Card.Text>
                    <ListGroup variant="flush">
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Total Supply</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small>Item 2</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>CMPG/day Reward</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small>Item 2</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Treasure Asset Value</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small>Item 2</small>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <div className="ms-2 me-auto">
                          <small>Daily Tx Fee Revenue</small>
                        </div>
                        <div className="ms-2 me-auto">
                          <small>Item 2</small>
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </Card.Body>
                  <Card.Footer>
                    <InputGroup className="">
                      <InputGroup.Text id="basic-addon1">Ci</InputGroup.Text>
                      <FormControl
                        placeholder="Recipient's username"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                    </InputGroup>
                    <Button variant="outline-primary" size="md" style={{marginTop:'10px', marginBottom:'10px'}}>Withdraw</Button>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
            <Row style={{ paddingTop: '1rem' }}>
              <Col xs={12} md={12} lg={12}>
                <Card>
                  <Card.Body>
                    <div className="CMPG-table">
                      <table className="table">
                        <thead className="CMPG-thead">
                          <tr>
                            <th>CMPG TOKEN</th>
                            <th>Token Quantity</th>
                            <th>USD Value</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {cmpgData.map((item, key) => {
                            return (
                              <tr key={key}>
                                <td><Icon name={item.tokenName} size={25} /><label style={{marginLeft:'10px', textTransform:'uppercase'}}>{item.tokenName}</label></td>
                                <td>{item.quantity}</td>
                                <td>{`$${item.usdValue}`}</td>
                                <td><Button onClick={() => setShowClaimDetailModal(true)} variant="primary">Claim</Button></td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col  xs={12} md={5} lg={5}>
            <Card>
              <Card.Body>
                <Card.Title><label className="card-title-small">vote selection</label></Card.Title>
                <div className="vote-selection">
                  <table className="table">
                    <tbody>
                      {
                        voteSectionData.map((item, key) => {
                          return (
                            <tr key={key}>
                              <td>{item.description}</td>
                              <td className="text-muted"><FontAwesomeIcon icon={faThumbsUp} color={item.status===1?"#20c997":""} size="lg" /></td>
                              <td className="text-muted"><FontAwesomeIcon icon={faThumbsDown} color={item.status===0?"#eb5757":""} size="lg"/></td>
                              <td className="vote-progress"><ProgressBar now={item.progress} label={`${item.progress}%`} /></td>
                              <td><a href="#" className="text-decoration-none" onClick={()=> setShowVoteDetailModal(true)}>Details</a></td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/*detail modal */}
        <ClaimDetailModal
          show={showClaimDetailModal}
          onHide={() => setShowClaimDetailModal(false)}
        />
        <VoteDetailModal 
          show={showVoteDetailModal}
          onHide={() => setShowVoteDetailModal(false)}
        />
        {/*  */}
      </Container>
    );
};

export default Governance;